import * as moment from 'moment';

export function isLocalUsingMeridianNotation(): boolean {
  return (
    moment
      .localeData()
      .longDateFormat('LT')
      .toLowerCase()
      .indexOf('a') > -1
  );
}
